import React, { Fragment, useEffect, useState } from 'react';
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import UserHttp from '../services/profile.service';
import { userStore } from '../../../store/UserStore';
import styled from '../styles.css';
import CreateSubAccount from './create-sub-account';
import CustomerOnboardingHttp from '../../customer-onboarding/services/customer.service';
import { responsiveFontSizes } from '@material-ui/core';
import {
  Formik,
  Field,
  Form as FormikForm,
  FormikHelpers,
  ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
interface PropsType {
  onCloseModal: any;
  OpenModal: any;
  accountId: any;
  customerId: any;
  setCustomer: any;
  customer: any;
  shippingAddress: any;
}
interface FormValues {
  address1: any;
  pinCode: any;
}

const UpdateNewAddress: React.FC<PropsType> = ({
  onCloseModal,
  OpenModal,
  accountId,
  customerId,
  setCustomer,
  customer,
  shippingAddress,
}) => {
  const [editAddress, setEditAddress] = useState(false);
  const [isPincodeDisabled, setIsPincodeDisabled] = useState(false);
  const [pincode, setPincode] = useState(shippingAddress?.pinCode);
  const [selectedState, setSelectedState] = useState('');
  const [pinCodeAvailable, setPinCodeAvailable] = useState(true);
  const [newAddress, setNewAddress] = useState({
    address1: shippingAddress?.address1,
    address2: shippingAddress?.address2,
    city: '',
  });
  const [user] = userStore((state: any) => [state.user]);
  const changeAddress = (e: any) => {
    const { name, value } = e.target;
    setNewAddress((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateFunction = async (values, setFieldError) => {
    console.log(values, 'values');
    console.log(selectedState, 'selected');
    // console.log(
    //   profile.data.data.customer?.accounts[0]?.account?.shippingAddress?.state,
    //   '-----'
    // );

    const data = {
      accountId: accountId,
      shippingAddress: {
        ...newAddress,
        pinCode: pincode,
        state: selectedState !== '' ? selectedState : shippingAddress?.state,
      },
    };
    try {
      const response:any = await UserHttp.updateShippingAddress(
        accountId,
        data,
        user?.userId
      );
      //dev-api.ebullion.in/customer-profile/615471
      if (response.status == 200) {
        const profile = await UserHttp.getProfile(customerId, user?.userId);
        setCustomer(profile.data.data.customer);
       
        setNewAddress({
          address1:
            profile.data.data.customer?.accounts[0]?.account?.shippingAddress
              ?.address1,
          address2:
            profile.data.data.customer?.accounts[0]?.account?.shippingAddress
              ?.address2,
          city: '',
        });
        setPincode(
          profile.data.data.customer?.accounts[0]?.account?.shippingAddress 
            ?.pinCode
        );
        setSelectedState(
          profile.data.data.customer?.accounts[0]?.account?.shippingAddress
            ?.state
        );
      }
      onCloseModal();
      toast.success('Address Updated Successfully');
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };

  const handlePincodeChange = async (e: any, setFieldValue: any) => {
    let value = e.target.value;
  
    // Remove any non-numeric characters and limit the length to 6 digits
    const numericValue = value.replace(/\D/g, '').slice(0, 6);
  
    setPincode(numericValue);
    setFieldValue('pinCode', numericValue);
  
    // if (numericValue.length < 6) {
    //   toast.error('Please enter a valid pincode with 6 digits');
    //   return; // stop further execution if pincode is not valid
    // }
  
    const res = await checkPincode(numericValue);
    if (numericValue?.length === 6 && !res) {
      setPinCodeAvailable(false);
      toast.error('Please enter a valid pincode');
    }
    else
    {
      setPinCodeAvailable(true);
    }
  };
  

  const checkPincode = async (pincode) => {
    if (pincode?.length === 6) {
      try {
        // setIsPincodeDisabled(true);
        const response: any = await CustomerOnboardingHttp.getStatebyPincode(
          pincode
        );
        if (response.status == 200 && response.data) {
          setPincode(pincode);

          setSelectedState(response.data?.data?.stateName);
          setIsPincodeDisabled(false);
          return true;
        }
      } catch (error) {
        setIsPincodeDisabled(false);
        return false;
      }
    } else {
      return false;
    }
  };

  const validationSchema = Yup.object().shape({
    address1: Yup.string().required('Address line 1 is required'),
    pinCode: Yup.string()
    .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits')
    .required('Pincode is required'),
  });

  return (
    <>
      <Modal show={OpenModal} onHide={onCloseModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Update Address</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            address1: shippingAddress?.address1 || '',
            pinCode: shippingAddress?.pinCode || '',
          }}
          validationSchema={validationSchema}
          onSubmit={(
            values,
            {
              setFieldError,
              setFieldTouched,
              setFieldValue,
              resetForm,
            }: FormikHelpers<FormValues>
          ) => {
            updateFunction(values, setFieldError);
            //   resetForm({ values: '' });
          }}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            setFieldError,
            setFieldTouched,
            setErrors,
            setTouched,
            validateField,
          }) => (
            <FormikForm>
              <>
                {/* <pre>{JSON.stringify(values)}</pre>
                <pre>{JSON.stringify(errors)}</pre>
                <pre>{JSON.stringify(touched)}</pre> */}
                <Modal.Body>
                  <Form.Group className='mb-2' controlId='formBasicAddressLine'>
                    <Form.Label>Address Line</Form.Label>
                    <Field
                      className='form-control form-control1'
                      as='textarea'
                      name='address1'
                      placeholder='AddressLine1'
                      defaultValue={shippingAddress?.address1}
                      onBlur={(e) => {
                        setFieldTouched('address1');
                      }}
                      onChange={(e: any) => {
                        setFieldValue('address1', e.target.value);
                        setNewAddress({
                          ...newAddress,
                          address1: e.target.value,
                        });
                        changeAddress(e);
                      }}
                    />
                    <div className='error text-danger ml-2'>
                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                      <ErrorMessage name='address1'>
                        {(msg) => <span className='error'>{msg}</span>}
                      </ErrorMessage>
                    </div>
                  </Form.Group>
                  <Form.Group
                    className='mb-2'
                    controlId='formBasicAddressLine2'
                  >
                    <Form.Label>Address Line 2</Form.Label>
                    <Field
                      className='form-control form-control1'
                      as='textarea'
                      name='address2'
                      placeholder='AddressLine2'
                      rows={3}
                      onChange={(e: any) => {
                        changeAddress(e);
                      }}
                      defaultValue={shippingAddress?.address2}
                    />
                  </Form.Group>
                  <Row>
                    <Col xs={12} md={6}>
                      <Form.Group className='mb-3' controlId='formBasicPincode'>
                        <Form.Label>Pincode</Form.Label>
                        <Field
                          className='form-control form-control1'
                          type='text'
                          name='pinCode'
                          maxLength={6}
                          placeholder='Pincode'
                          onBlur={(e) => {
                            setFieldTouched('pinCode');
                          }}
                          onChange={(e: any) => handlePincodeChange(e, setFieldValue)}
                          defaultValue={shippingAddress?.pinCode}
                        />
                      </Form.Group>
                      <div className='error text-danger ml-2'>
                        {/* {errors.pinCode && touched.pinCode && (
                          <small id='my-helper-text '>{errors.pinCode}</small>
                        )} */}
                        <ErrorMessage name='pinCode'>
                          {(msg) => <span className='error'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </Col>

                    <Col xs={12} md={6}>
                      <Form.Group className='mb-3' controlId='formBasicState'>
                        <Form.Label>State</Form.Label>
                        <Form.Control
                          className='form-control form-control1'
                          type='text'
                          name='state'
                          disabled
                          // value={selectedState}
                          placeholder={shippingAddress?.state}
                          defaultValue={selectedState}
                        />
                      </Form.Group>
                    </Col>
                    {/* <Col xs={12} md={4}>
              <Form.Group className='mb-3' controlId='formBasicCity'>
                <Form.Label>City</Form.Label>
                <Form.Control type='text' name='city' placeholder='City' />
              </Form.Group>
            </Col> */}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='primary' type='submit' disabled={!pinCodeAvailable}>
                    Update
                  </Button>
                  <Button variant='secondary' onClick={onCloseModal}>
                    Close
                  </Button>
                  {/* <Button variant='primary' onClick={() => updateFunction()}>
            Update
          </Button> */}
                </Modal.Footer>
              </>
            </FormikForm>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default UpdateNewAddress;
